// Components
import {
  Alert,
  Card,
  CardContent,
  CircularProgress,
  Divider,
  FormControlLabel,
  Stack,
  Switch,
  Typography,
} from "@mui/material";

// Icons
import AssignmentIcon from "@mui/icons-material/Assignment";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";

const BusinessDetails = ({ user }) => {
  const radius = {
    regional: user?.trajet?.regional ?? false,
    national: user?.trajet?.national ?? false,
    international: user?.trajet?.international ?? false,
  };

  const expeditionsType = {
    ftl: user?.type_expedition?.ftl ?? false,
    ltl: user?.type_expedition?.ltl ?? false,
  };

  const goodTypes = {
    palette: user?.type_marchandise?.palette ?? false,
    vrac: user?.type_marchandise?.vrac ?? false,
    alimentaire: user?.type_marchandise?.alimentaire ?? false,
    danger: user?.type_marchandise?.danger ?? false,
    spcilisees: user?.type_marchandise?.specialisees ?? false,
    autre: user?.type_marchandise?.autre ?? false,
  };

  const truckTypes = {
    truckPL7: user?.type_truck?.truckPL7 ?? false,
    truckSPL: user?.type_truck?.truckSPL ?? false,
    truckVan: user?.type_truck?.truckVan ?? false,
    truck20M3: user?.type_truck?.truck20M3 ?? false,
    truckPL12: user?.type_truck?.truckPL12 ?? false,
    truckPL19: user?.type_truck?.truckPL19 ?? false,
  };

  let expeditionsCount = null;
  switch (user?.expeditions_count) {
    case "s":
      expeditionsCount = "Entre 0 et 5 expéditions";
      break;
    case "m":
      expeditionsCount = "Entre 5 et 15 expéditions";
      break;
    case "l":
      expeditionsCount = "Entre 15 et 50 expéditions";
      break;
    case "xxl":
      expeditionsCount = "Plus de 50 expéditions";
      break;
    default:
      expeditionsCount = "--";
  }

  let vehiclesCount = null;
  switch (user?.vehicule_number) {
    case "s":
      vehiclesCount = "Un seul véhicule";
      break;
    case "m":
      vehiclesCount = "Entre 2 et 5 véhicules";
      break;
    case "l":
      vehiclesCount = "Entre 5 et 20 véhicules";
      break;
    case "xxl":
      vehiclesCount = "Plus de 20 véhicules";
      break;
    default:
      vehiclesCount = "--";
  }

  const renderBooleanValue = (label, value) => {
    let icon = value ? (
      <CheckIcon sx={{ color: "success.main", width: 18 }} />
    ) : (
      <CloseIcon sx={{ color: "error.main", width: 18 }} />
    );
    return (
      <Stack direction="row" alignItems="center" spacing={1}>
        {icon} <Typography>{label}</Typography>
      </Stack>
    );
  };

  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2, display: "flex", gap: 1 }}>
          <AssignmentIcon /> Entreprise
        </Typography>

        <Divider sx={{ mb: 2 }} />

        <Stack spacing={2}>
          {user?.expeditions_count && (
            <>
              <Stack direction="row" alignItems="center" spacing={2}>
                <Typography sx={{ color: "text.secondary" }}>Nombre d'éxpéditions par mois : </Typography>
                <Typography>{expeditionsCount}</Typography>
              </Stack>
              <Divider sx={{ mb: 2 }} />
            </>
          )}

          {user?.vehicule_number && (
            <>
              <Stack direction="row" alignItems="center" spacing={2}>
                <Typography sx={{ color: "text.secondary" }}>Nombre de véhicules : </Typography>
                <Typography>{vehiclesCount}</Typography>
              </Stack>
              <Divider sx={{ mb: 2 }} />
            </>
          )}

          {user?.trajet && (
            <>
              <Stack direction="row" alignItems="center" spacing={2}>
                <Typography sx={{ color: "text.secondary" }}>Rayon des éxpéditions : </Typography>
                <Stack direction="row" alignItems="center" spacing={4}>
                  {renderBooleanValue("Régional", radius.regional)}
                  {renderBooleanValue("National", radius.national)}
                  {renderBooleanValue("International", radius.international)}
                </Stack>
              </Stack>
              <Divider sx={{ mb: 2 }} />
            </>
          )}

          {user?.type_marchandise && (
            <>
              <Stack direction="row" alignItems="center" spacing={2}>
                <Typography sx={{ color: "text.secondary" }}>Types de marchandises : </Typography>
                <Stack direction="row" alignItems="center" spacing={4}>
                  {renderBooleanValue("Palette", goodTypes.palette)}
                  {renderBooleanValue("Vrac", goodTypes.vrac)}
                  {renderBooleanValue("Alimentaire", goodTypes.alimentaire)}
                  {renderBooleanValue("Dangereuse", goodTypes.danger)}
                  {renderBooleanValue("Machines spécialisées", goodTypes.spcilisees)}
                  {renderBooleanValue("Autre", goodTypes.autre)}
                </Stack>
              </Stack>
              <Divider sx={{ mb: 2 }} />
            </>
          )}

          {user?.type_expedition && user?.type_expedition?.length > 0 && (
            <>
              <Stack direction="row" alignItems="center" spacing={2}>
                <Typography sx={{ color: "text.secondary" }}>Type d'éxpéditions : </Typography>
                <Stack direction="row" alignItems="center" spacing={4}>
                  {renderBooleanValue("Camions complets (FTL)", expeditionsType.ftl)}
                  {renderBooleanValue("Camions partiels (LTL)", expeditionsType.ltl)}
                </Stack>
              </Stack>
              <Divider sx={{ mb: 2 }} />
            </>
          )}

          {user?.type_truck && user?.types_truck?.length > 0 && (
            <>
              <Stack direction="row" alignItems="center" spacing={2}>
                <Typography sx={{ color: "text.secondary" }}>Types de camions : </Typography>
                <Stack direction="row" alignItems="center" spacing={4}>
                  {renderBooleanValue("PL 7 tonnes", truckTypes.truckPL7)}
                  {renderBooleanValue("SPL", truckTypes.truckSPL)}
                  {renderBooleanValue("Fourgon", truckTypes.truckVan)}
                  {renderBooleanValue("20m3", truckTypes.truck20M3)}
                  {renderBooleanValue("PL 12 tonnes", truckTypes.truckPL12)}
                  {renderBooleanValue("PL 19 tonnes", truckTypes.truckPL19)}
                </Stack>
              </Stack>
            </>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default BusinessDetails;
